export default "/images/vendor/flag-icon-css/flags/1x1/ht.svg?593507644b4be0c259ffc237ef784d44";